import React from 'react'
import { useHistory } from 'react-router-dom';
import "./Checkout.css"
import CheckoutProduct from './CheckoutProduct';
import Banner from "./images/wuzi__ad.jpg"
import { useStateValue } from './StateProvider';
import SubTotal from './SubTotal';

function Checkout() {
    const [{ cart, user }, dispatch] = useStateValue();

    return (
        <div className="checkout">
            <div className="checkout__left">
                <img className="checkout__ad" src={Banner} alt="advertisment banner" />
                
                <h3 className="user_checkour_header">Your shopping cart, {user?.email}</h3>
                <div className="checkout__title">
                
                    {cart.map(item => (
                        <CheckoutProduct
                            id={item.id}
                            title={item.title}
                            image={item.image}
                            price={item.price}
                            rating={item.rating}
                      />
                ))}
                    
                    <h1>NO ITEMS HERE....</h1>
                    <h1>ADD AN OUTFIT TO CART</h1><h1>LIKE A BANTU LOOK</h1>
                    <h1>OR FROM RAY'S DESIGNS.</h1>
                <h1>THEY WILL APPEAR HERE!</h1>
                </div>
            </div>
            
            <div className="checkout__right">
            <SubTotal />
            </div>


        </div>
    )
}

export default Checkout;
